import "@/instrument";
import { sentryReactErrorHandler, SentryErrorBoundary } from "@/instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// React 19 pattern: register Sentry's uncaught/caught/recoverable error
// handlers on the root itself. Falls through to no-ops when Sentry is
// disabled (preview / dev builds).
const rootErrorHandler = sentryReactErrorHandler ? sentryReactErrorHandler() : undefined;

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError: rootErrorHandler,
  onCaughtError: rootErrorHandler,
  onRecoverableError: rootErrorHandler,
});

root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={({ resetError }) => (
      <div style={{ padding: 40, fontFamily: "system-ui", textAlign: "center" }}>
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>Something went wrong.</h1>
        <p style={{ color: "#64748b", marginBottom: 20 }}>
          Our team has been notified. Please refresh the page to continue.
        </p>
        <button
          onClick={() => { resetError(); window.location.reload(); }}
          style={{ padding: "10px 20px", background: "#065f46", color: "white", border: 0, borderRadius: 6, cursor: "pointer", fontWeight: 600 }}
        >
          Refresh
        </button>
      </div>
    )}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
